import { render, staticRenderFns } from "./Reduce_debt_details_success.vue?vue&type=template&id=5b0e4de9&scoped=true&"
import script from "./Reduce_debt_details_success.vue?vue&type=script&lang=js&"
export * from "./Reduce_debt_details_success.vue?vue&type=script&lang=js&"
import style0 from "./Reduce_debt_details_success.vue?vue&type=style&index=0&id=5b0e4de9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e4de9",
  null
  
)

export default component.exports